import $ from 'jquery';
import City from 'portlets/site/order/city/city';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderNoCity',
			dom: {
				city: '.js-city'
			},
			callback: {
				set: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$city = this.$el.find(this.options.dom.city);
		return this;
	}

	onCitySet(data) {
		if (typeof this.options.callback.set == 'function') {
			this.options.callback.set(data, 'nocity');
		}
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();


			self.city = new City({
				el: self.$city,
				callback: {
					set: self.onCitySet.bind(self)
				}
			}).render();
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order/nocity/nocity.js